// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-order-header {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  /* Header/H1 Bold */
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.336px;
  margin-bottom: 0px;
}

.arrow-icon {
  margin-top: 2px;
}

.arrow-back {
  margin-bottom: 3px;
  width: 32px;
  height: 32px;
  margin-right: 3px;
  cursor: pointer;
}

.transaction-back-div {
  margin-top: 14px;
  margin-left: 14px;
  height: 14px;
}
.content {
  margin: 0px 12px 0px 12px;
}

.whole-page-body {
  background-color: white;
}

.transaction-page-link {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-size: 14px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.order-page-link {
  color: var(--text-high, rgba(1, 1, 2, 0.72));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.header-card {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
  /* Header/H3 Medium */
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.24px;
}

.card-inner-headers {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  /* Label/Semi bold */
  font-size: 12px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  margin-bottom: 0px;
}

.card-inner-headers-radio {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  /* Body/B2 Medium */
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 0px;
  margin-left: 8px;
}

.refund-field.MuiFormControl-root {
  margin: 0px;
  border-radius: 8px;
  border: 1px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  background: var(--background-disabled, rgba(1, 1, 2, 0.04));
}

.refund-field.MuiInputBase-root.MuiOutlinedInput-root {
  width: 320px;
  height: 40px;
  font-family: "Poppins";
}

.refund-field-input.MuiInputBase-root.MuiOutlinedInput-root {
  height: 40px;
  width: 320px;
  color: var(--text-low, rgba(1, 1, 2, 0.45));

  /* Body/B2 Regular */
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.refund-field-text {
  color: var(--text-high, rgba(1, 1, 2, 0.72));

  /* Label/Medium */
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding-top: 16.5px;
}

.inner-header-content {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  /* Body/B2 Semi bold */
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.whole-card-body {
  margin-top: 18px;
}

.refund-button.MuiButtonBase-root.MuiButton-root {
  display: flex;
  width: 175px;

  height: 42px;
  font-family: "Poppins";
  min-width: 60px;
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background-color: var(--generic-primary-accent, #403e9f);
}

.refund-button-modal.MuiButtonBase-root.MuiButton-root {
  display: flex;
  width: 175px;

  height: 42px;
  font-family: "Poppins";
  min-width: 60px;
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background-color: var(--generic-primary, #24b7aa);
}

.void-button.MuiButtonBase-root.MuiButton-root {
  display: flex;
  width: 175px;
  font-family: "Poppins";
  height: 42px;
  min-width: 60px;
  padding: 0px 24px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1.6px solid var(--generic-primary-accent, #403e9f);
}

.cancel-button-modal.MuiButtonBase-root.MuiButton-root {
  display: flex;
  width: 175px;

  height: 42px;
  font-family: "Poppins";
  min-width: 60px;
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  color: var(--generic-primary, #24b7aa);
  border: 2px solid var(--generic-primary, #24b7aa);
}

@media (max-width: 500px) {
  .refund-button {
    width: auto;
  }
}

.card {
  border-radius: 12px;
  border: 1.2px solid var(--border-secondary, rgba(1, 1, 2, 0.45));
  box-shadow: 0px;
}

.label-text {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  /* Body/B2 Semi bold */
  font-size: 14px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  margin-top: 8px;
}

.modal-header {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  /* Header/H3 Bold */
  font-size: 20px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.24px;
  padding-left: 0px;
  padding-top: 0px;
}

.modal-sub-header {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  /* Sub Header/Medium */
  font-size: 18px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  margin-top: 22px;
}

.modal-radio-button {
  width: 16px;
  height: 16px;
}

.modal-buttons-div {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 32px;
  right: 32px;
}

.refund-header-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.cross-icon-modal {
  margin-top: 6px;
  cursor: pointer;
}

.status-tab-text {
  color: var(--comms-positive, #0b6a48);

  /* Label/Regular */
  font-size: 12px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 4px 8px;
  border-radius: 4px;
  /* background: var(--comms-positive-sub, #d5fbd2); */
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.authorization-timeline-card.MuiPaper-root.MuiCard-root {
  width: 812px;
  height: auto;
  display: flex;
  /* padding: 16px 24px; */
  align-items: center;
  gap: 31px;
  flex: 1 0 0;
  border-radius: 0px 12px 12px 0px;
  background: var(--background-secondary, #f4f4f4);
}

.authorization-timeline-content.MuiCardContent-root {
  padding: 16px 24px 16px 24px !important;
}

.authorization-timeline-content.MuiCardContent-root:last-child {
  padding: 0;
}

.timeline-header {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  /* Sub Header/Semi bold */
  font-size: 18px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 0px;
}

.timeline-subheader {
  color: var(--text-high, rgba(1, 1, 2, 0.72));

  /* Body/B2 Semi bold */
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  padding-top: 12px;
}

.timeline-datetime {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  /* Body/B2 Medium */
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 0;
}

.timeline-seperator {
  width: 18px;
  transform: rotate(90deg);
  align-self: stretch;
}

.timeline-seperator.MuiDivider-root {
  margin-top: 8px;
}

.secondCard-timeline.MuiPaper-root.MuiCard-root {
  display: flex;
  align-items: center;
  gap: 31px;
  flex: 1 0 0;
  width: 912px;
  border-radius: 0px 12px 12px 0px;
  background: var(--background-secondary, #f4f4f4);
}

.border-div {
  width: 4px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 12px 0px 0px 12px;
  background: var(--generic-primary-accent, #403e9f);
}

.errorMessageTimeline.MuiTypography-root {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  flex-grow: 1; 
}
.messageTimeline {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  white-space: normal; 
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/orderManagement/OrderDetails/orderDetails.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;;EAE/C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;;EAE7C,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;;EAE/C,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2CAA2C;;EAE3C,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;;EAE5C,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;;EAE/C,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;;EAEZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,YAAY;;EAEZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,YAAY;;EAEZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,+CAA+C;;EAE/C,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;;EAE/C,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;;EAErC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+CAA+C;;EAE/C,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;;EAE5C,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;;EAE7C,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".main-order-header {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  /* Header/H1 Bold */\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px;\n  letter-spacing: -0.336px;\n  margin-bottom: 0px;\n}\n\n.arrow-icon {\n  margin-top: 2px;\n}\n\n.arrow-back {\n  margin-bottom: 3px;\n  width: 32px;\n  height: 32px;\n  margin-right: 3px;\n  cursor: pointer;\n}\n\n.transaction-back-div {\n  margin-top: 14px;\n  margin-left: 14px;\n  height: 14px;\n}\n.content {\n  margin: 0px 12px 0px 12px;\n}\n\n.whole-page-body {\n  background-color: white;\n}\n\n.transaction-page-link {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  font-size: 14px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n.order-page-link {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.header-card {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n  /* Header/H3 Medium */\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n  letter-spacing: -0.24px;\n}\n\n.card-inner-headers {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  /* Label/Semi bold */\n  font-size: 12px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 14px;\n  margin-bottom: 0px;\n}\n\n.card-inner-headers-radio {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  /* Body/B2 Medium */\n  font-size: 14px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  margin-bottom: 0px;\n  margin-left: 8px;\n}\n\n.refund-field.MuiFormControl-root {\n  margin: 0px;\n  border-radius: 8px;\n  border: 1px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  background: var(--background-disabled, rgba(1, 1, 2, 0.04));\n}\n\n.refund-field.MuiInputBase-root.MuiOutlinedInput-root {\n  width: 320px;\n  height: 40px;\n  font-family: \"Poppins\";\n}\n\n.refund-field-input.MuiInputBase-root.MuiOutlinedInput-root {\n  height: 40px;\n  width: 320px;\n  color: var(--text-low, rgba(1, 1, 2, 0.45));\n\n  /* Body/B2 Regular */\n  font-size: 14px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.refund-field-text {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n\n  /* Label/Medium */\n  font-size: 12px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  padding-top: 16.5px;\n}\n\n.inner-header-content {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  /* Body/B2 Semi bold */\n  font-size: 14px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n.whole-card-body {\n  margin-top: 18px;\n}\n\n.refund-button.MuiButtonBase-root.MuiButton-root {\n  display: flex;\n  width: 175px;\n\n  height: 42px;\n  font-family: \"Poppins\";\n  min-width: 60px;\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background-color: var(--generic-primary-accent, #403e9f);\n}\n\n.refund-button-modal.MuiButtonBase-root.MuiButton-root {\n  display: flex;\n  width: 175px;\n\n  height: 42px;\n  font-family: \"Poppins\";\n  min-width: 60px;\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background-color: var(--generic-primary, #24b7aa);\n}\n\n.void-button.MuiButtonBase-root.MuiButton-root {\n  display: flex;\n  width: 175px;\n  font-family: \"Poppins\";\n  height: 42px;\n  min-width: 60px;\n  padding: 0px 24px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 8px;\n  border: 1.6px solid var(--generic-primary-accent, #403e9f);\n}\n\n.cancel-button-modal.MuiButtonBase-root.MuiButton-root {\n  display: flex;\n  width: 175px;\n\n  height: 42px;\n  font-family: \"Poppins\";\n  min-width: 60px;\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  color: var(--generic-primary, #24b7aa);\n  border: 2px solid var(--generic-primary, #24b7aa);\n}\n\n@media (max-width: 500px) {\n  .refund-button {\n    width: auto;\n  }\n}\n\n.card {\n  border-radius: 12px;\n  border: 1.2px solid var(--border-secondary, rgba(1, 1, 2, 0.45));\n  box-shadow: 0px;\n}\n\n.label-text {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  /* Body/B2 Semi bold */\n  font-size: 14px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n  margin-top: 8px;\n}\n\n.modal-header {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  /* Header/H3 Bold */\n  font-size: 20px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  line-height: 28px;\n  letter-spacing: -0.24px;\n  padding-left: 0px;\n  padding-top: 0px;\n}\n\n.modal-sub-header {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  /* Sub Header/Medium */\n  font-size: 18px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  margin-top: 22px;\n}\n\n.modal-radio-button {\n  width: 16px;\n  height: 16px;\n}\n\n.modal-buttons-div {\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  bottom: 32px;\n  right: 32px;\n}\n\n.refund-header-div {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.cross-icon-modal {\n  margin-top: 6px;\n  cursor: pointer;\n}\n\n.status-tab-text {\n  color: var(--comms-positive, #0b6a48);\n\n  /* Label/Regular */\n  font-size: 12px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  margin-bottom: 0px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  /* background: var(--comms-positive-sub, #d5fbd2); */\n  display: flex;\n  padding: 4px 8px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.authorization-timeline-card.MuiPaper-root.MuiCard-root {\n  width: 812px;\n  height: auto;\n  display: flex;\n  /* padding: 16px 24px; */\n  align-items: center;\n  gap: 31px;\n  flex: 1 0 0;\n  border-radius: 0px 12px 12px 0px;\n  background: var(--background-secondary, #f4f4f4);\n}\n\n.authorization-timeline-content.MuiCardContent-root {\n  padding: 16px 24px 16px 24px !important;\n}\n\n.authorization-timeline-content.MuiCardContent-root:last-child {\n  padding: 0;\n}\n\n.timeline-header {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  /* Sub Header/Semi bold */\n  font-size: 18px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  margin-bottom: 0px;\n}\n\n.timeline-subheader {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n\n  /* Body/B2 Semi bold */\n  font-size: 14px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n  padding-top: 12px;\n}\n\n.timeline-datetime {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  /* Body/B2 Medium */\n  font-size: 14px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  margin-bottom: 0;\n}\n\n.timeline-seperator {\n  width: 18px;\n  transform: rotate(90deg);\n  align-self: stretch;\n}\n\n.timeline-seperator.MuiDivider-root {\n  margin-top: 8px;\n}\n\n.secondCard-timeline.MuiPaper-root.MuiCard-root {\n  display: flex;\n  align-items: center;\n  gap: 31px;\n  flex: 1 0 0;\n  width: 912px;\n  border-radius: 0px 12px 12px 0px;\n  background: var(--background-secondary, #f4f4f4);\n}\n\n.border-div {\n  width: 4px;\n  flex-shrink: 0;\n  align-self: stretch;\n  border-radius: 12px 0px 0px 12px;\n  background: var(--generic-primary-accent, #403e9f);\n}\n\n.errorMessageTimeline.MuiTypography-root {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  flex-grow: 1; \n}\n.messageTimeline {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  white-space: normal; \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
